const {
  i18n: { __ },
  components: { TextControl },
} = wp;

const MarketoSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { marketoForm } = attributes;

  return (
    <>
      <TextControl
        label={__('Marketo Base URL', 'b3rg')}
        value={marketoForm.marketoBaseUrl}
        onChange={(newValue) => {
          setAttributes({
            marketoForm: {
              ...marketoForm,
              marketoBaseUrl: newValue,
            },
          });
        }}
      />

      <TextControl
        label={__('Munchkin ID', 'b3rg')}
        value={marketoForm.munchkinId}
        onChange={(newValue) => {
          setAttributes({
            marketoForm: {
              ...marketoForm,
              munchkinId: newValue,
            },
          });
        }}
      />

      <TextControl
        label={__('Form ID', 'b3rg')}
        value={marketoForm.marketoFormId}
        onChange={(newValue) => {
          setAttributes({
            marketoForm: {
              ...marketoForm,
              marketoFormId: newValue,
            },
          });
        }}
      />
    </>
  );
};

export default MarketoSettings;
